import HomeSection from './HomeSection';
import HomeSectionContainer from './HomeSection.container';

export default HomeSectionContainer(HomeSection);
